import { AlertTriangle, DoorOpen, Droplets, Flame, Sparkles, ShieldCheck, Smartphone, KeyRound } from "lucide-react";

const risks = [
  { icon: DoorOpen, title: "Einbruch & Vandalismus", desc: "Leerstehende Objekte sind ein Magnet für Einbrecher und mutwillige Schäden – schon vor dem Verkauf." },
  { icon: Droplets, title: "Wasserschäden", desc: "Ein platzendes Rohr oder ein undichter Anschluss – unbemerkt entstehen Schäden im fünfstelligen Bereich." },
  { icon: Flame, title: "Brand & Rauch", desc: "Elektrik-Defekte oder Fremdverschulden – ohne Rauchmelder bleiben Vorfälle zu lange unentdeckt." },
  { icon: AlertTriangle, title: "Wertverlust", desc: "Schäden während der Vermarktung mindern den Verkaufspreis oder verzögern den Deal." },
];

const benefits = [
  { icon: ShieldCheck, title: "Sicheres Gefühl", desc: "Käufer spüren sofort: Diese Immobilie ist geschützt. Ein starker emotionaler Kaufimpuls." },
  { icon: KeyRound, title: "Bezugsfertige Sicherheit", desc: "Der Käufer übernimmt die Anlage – ohne Aufwand, ohne Wartezeit. Ein klarer Premium-Vorteil." },
  { icon: Smartphone, title: "Smarte App-Steuerung", desc: "Alles per Handy: Push-Alarme, Live-Status, Historie. Modern, komfortabel, überzeugend." },
  { icon: Sparkles, title: "Verkaufsargument im Exposé", desc: "„Inkl. professioneller Alarmanlage“ hebt Ihr Objekt aus der Masse heraus – bei Portalen und Besichtigungen." },
];

export const RisksBenefits = () => {
  return (
    <section id="benefits" data-testid="risks-benefits-section" className="ss-section bg-slate-50">
      <div className="ss-container">
        <div className="max-w-3xl">
          <span className="ss-eyebrow">Die Verkaufsphase</span>
          <h2 className="ss-h2 mt-4 text-slate-900">Leerstand sichern &amp; Wert steigern.</h2>
          <p className="ss-lead mt-4">
            Sicherheitsrisiken links, Verkaufsvorteile rechts – so wird aus einem Risiko-Zeitraum eine Chance für den Bestpreis.
          </p>
        </div>

        <div className="mt-12 grid lg:grid-cols-2 gap-6 lg:gap-8">
          {/* Risks column */}
          <div
            className="rounded-2xl bg-white border border-slate-200/80 p-6 sm:p-8 shadow-[0_10px_30px_rgba(2,6,23,0.05)]"
            data-testid="risks-column"
          >
            <div className="flex items-center gap-2 text-sm font-semibold text-red-600">
              <AlertTriangle className="h-4 w-4" />
              <span className="uppercase tracking-wider">Risiken minimieren</span>
            </div>
            <h3 className="ss-h3 mt-3 text-slate-900">Was passieren kann, wenn nichts passiert.</h3>

            <ul className="mt-6 space-y-4">
              {risks.map((r) => (
                <li key={r.title} className="flex gap-4 p-3 rounded-xl hover:bg-slate-50/80 transition">
                  <span className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-red-50 text-red-600 border border-red-100">
                    <r.icon className="h-5 w-5" />
                  </span>
                  <div>
                    <div className="font-semibold text-slate-900">{r.title}</div>
                    <p className="text-sm text-slate-600 mt-1 leading-relaxed">{r.desc}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          {/* Benefits column - navy */}
          <div
            className="relative rounded-2xl overflow-hidden bg-[#071A2B] text-white p-6 sm:p-8 border border-[var(--ss-gold)]/20 shadow-[0_20px_60px_rgba(7,26,43,0.25)]"
            data-testid="benefits-column"
          >
            <div className="absolute -left-20 -top-16 h-56 w-56 rounded-full bg-[var(--ss-gold)]/10 blur-3xl" aria-hidden="true" />
            <div className="relative flex items-center gap-2 text-sm font-semibold text-[var(--ss-gold)]">
              <Sparkles className="h-4 w-4" />
              <span className="uppercase tracking-wider">Verkaufsargumente schaffen</span>
            </div>
            <h3 className="relative ss-h3 mt-3 text-white">Käufernutzen, der Preise rechtfertigt.</h3>

            <ul className="relative mt-6 space-y-4">
              {benefits.map((b) => (
                <li key={b.title} className="flex gap-4 p-3 rounded-xl hover:bg-white/5 transition">
                  <span className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-[var(--ss-gold)]/15 text-[var(--ss-gold)] border border-[var(--ss-gold)]/25">
                    <b.icon className="h-5 w-5" />
                  </span>
                  <div>
                    <div className="font-semibold text-white">{b.title}</div>
                    <p className="text-sm text-slate-300 mt-1 leading-relaxed">{b.desc}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
